define('pagina-controller',[],
    function() {

  var app = angular.module('pagina.controller', ['pagina.resource'
    ]);


  app.controller('PaginaController', ['$scope', 'Pagina', "$metadata", function($scope, Pagina) {
    $scope.slider = false;
  }]);

});

